import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Uncaught React error:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 p-6 font-outfit">
          <div className="max-w-md w-full text-center space-y-5">
            <div className="text-6xl font-bold text-slate-200 dark:text-slate-700">500</div>
            <h1 className="text-xl font-bold text-slate-800 dark:text-white">Something went wrong</h1>
            <p className="text-sm text-slate-500 dark:text-slate-400">
              An unexpected error occurred. Your data is safe — try refreshing.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="px-5 py-2 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-xl text-sm transition-colors"
              >
                Reload page
              </button>
              <button
                onClick={() => { this.setState({ error: null }); window.location.href = "/dashboard"; }}
                className="px-5 py-2 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-semibold rounded-xl text-sm transition-colors"
              >
                Go to Dashboard
              </button>
            </div>
            {process.env.NODE_ENV === "development" && (
              <pre className="text-left text-xs bg-slate-100 dark:bg-slate-800 text-red-600 dark:text-red-400 rounded-xl p-4 overflow-auto max-h-48">
                {this.state.error.toString()}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
